import SectionHeading from './SectionHeading';

const PRINCIPLES = [
  { icon: 'ri-focus-3-line', title: '有信源才发布', desc: '以官方声明、公开报道与作品物料为依据，不编造、不捕风捉影。' },
  { icon: 'ri-refresh-line', title: '有反转必跟进', desc: '一旦事实出现更新或反转，我们会第一时间修正并同步说明。' },
  { icon: 'ri-lock-line', title: '隐私有边界', desc: '关注作品与行业动态，对未公开的私人生活始终保持克制。' },
  { icon: 'ri-lightbulb-line', title: '观点有依据', desc: '评论建立在事实之上，理性讨论，拒绝人身攻击与造谣。' },
];

const QUOTES = [
  { text: '更新快、整理细，早上刷一眼就能补上昨天的瓜，通勤路上很解压。', who: '读者 · 小鹿' },
  { text: '难得有平台会把反转说清楚，不会为了流量只放一半。', who: '读者 · 阿澈' },
  { text: '栏目分得明白，找想看的艺人动态特别省事。', who: '读者 · Nana' },
];

const CONTACT = 'hi@chigua.example.com';

export default function AboutSection() {
  return (
    <section id="about" className="bg-background-100/60 py-14 md:py-20">
      <div className="mx-auto max-w-6xl px-4 md:px-6 lg:px-8">
        <div className="overflow-hidden rounded-3xl border border-background-200/70 bg-background-50">
          <div className="grid grid-cols-1 lg:grid-cols-2">
            {/* left intro */}
            <div className="flex flex-col p-6 md:p-9">
              <SectionHeading
                eyebrow="关于我们"
                title="吃瓜八卦，是什么来头？"
                desc="我们是一群既爱作品也爱八卦的内容爱好者，专注把娱乐圈里分散的信息整理成清晰、可读、有分寸的资讯，做你追星路上的“信息整理员”。"
              />
              <div className="grid grid-cols-2 gap-4 sm:grid-cols-4">
                {[
                  { n: '30+', l: '每日更新热瓜' },
                  { n: '1800+', l: '累计梳理条目' },
                  { n: '6 类', l: '内容栏目覆盖' },
                  { n: '100%', l: '信源公开标注' },
                ].map((s) => (
                  <div key={s.l} className="rounded-2xl bg-background-100/70 p-4 text-center">
                    <p className="font-heading text-xl font-extrabold text-primary-600 md:text-2xl">
                      {s.n}
                    </p>
                    <p className="mt-1 font-label text-xs text-foreground-500">{s.l}</p>
                  </div>
                ))}
              </div>

              <p className="mt-6 text-sm leading-relaxed text-foreground-600">
                我们相信，追星和“吃瓜”不该是撕裂的：一边认真安利作品，一边也用理性看待争议。所以我们坚持用结构化栏目（演员、歌手、爱豆、综艺、电影、幕后）组织内容，让每个人都能快速找到感兴趣的板块。
              </p>

              <div className="mt-6 grid grid-cols-1 gap-3 sm:grid-cols-2">
                {PRINCIPLES.map((p) => (
                  <div
                    key={p.title}
                    className="flex items-start gap-3 rounded-2xl border border-background-200/70 bg-background-50 p-4"
                  >
                    <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-accent-100 text-accent-700">
                      <i className={`${p.icon} text-base`}></i>
                    </span>
                    <div>
                      <p className="font-heading text-sm font-bold text-foreground-950">{p.title}</p>
                      <p className="mt-1 text-xs leading-relaxed text-foreground-600">{p.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* right contact / voice */}
            <div className="flex flex-col gap-5 bg-gradient-to-br from-primary-500 to-primary-800 p-6 text-background-50 md:p-9">
              <div>
                <p className="font-label text-xs tracking-widest text-background-100/80">
                  与我们联系
                </p>
                <h3 className="mt-2 font-heading text-xl font-bold md:text-2xl">
                  爆料投稿 & 商务合作
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-background-100/85">
                  有第一手线索、想提供素材，或有任何建议，都欢迎给我们来信。投稿请尽量附上可核实的公开来源与时间，我们会先筛选再跟进。
                </p>
              </div>

              <a
                href={`mailto:${CONTACT}?subject=${encodeURIComponent('吃瓜八卦 · 投稿/合作')}`}
                className="group flex items-center justify-between gap-3 rounded-2xl border border-background-50/25 bg-background-50/10 px-5 py-4 backdrop-blur-sm transition-colors hover:bg-background-50/20"
              >
                <span className="flex items-center gap-3">
                  <span className="flex h-10 w-10 items-center justify-center rounded-full bg-background-50/15">
                    <i className="ri-mail-send-line text-lg"></i>
                  </span>
                  <span className="flex flex-col leading-tight">
                    <span className="text-sm text-background-100/80">投稿邮箱</span>
                    <span className="font-heading text-base font-semibold text-background-50">
                      {CONTACT}
                    </span>
                  </span>
                </span>
                <i className="ri-arrow-right-up-line text-xl transition-transform group-hover:translate-x-0.5"></i>
              </a>

              <div className="mt-auto">
                <p className="font-label text-xs tracking-widest text-background-100/70">读者说</p>
                <div className="mt-3 flex flex-col gap-2.5">
                  {QUOTES.map((q) => (
                    <blockquote
                      key={q.who}
                      className="rounded-2xl border border-background-50/20 bg-background-50/5 px-4 py-3"
                    >
                      <p className="text-sm leading-relaxed text-background-50/95">“{q.text}”</p>
                      <footer className="mt-1.5 text-xs text-background-100/70">—— {q.who}</footer>
                    </blockquote>
                  ))}
                </div>
              </div>

              <p className="text-xs leading-relaxed text-background-100/70">
                免责声明：本站内容以公开信息整理为主，供分享与讨论，不构成对任何个人或作品的评价与定性。如涉侵权或事实出入，请通过上方邮箱联系，我们将及时处理。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}